module.exports = __webpack_public_path__ + "static/media/KioskLoginScreen.371d5c02.png";